import { useSelector } from "react-redux";
import {
  isSuperAdmin,
  hasPermission,
  hasAnyPermission,
  hasAllPermissions,
  canAccessPostPaidModule,
  canCreatePostPaidRequest,
  canEditPostPaidRequest,
  canApproveAsHOD,
  canApproveAsFinance,
  canApproveRequest,
  getPostPaidPermissions,
  POST_PAID_PERMISSIONS,
} from "../utils/permissions";

export const usePermissions = () => {
  const admin = useSelector((state) => state.admin.txtconnect_ng_admin);

  return {
    admin,
    isSuperAdmin: () => isSuperAdmin(admin),
    hasPermission: (permission) => hasPermission(admin, permission),
    hasAnyPermission: (permissions) => hasAnyPermission(admin, permissions),
    hasAllPermissions: (permissions) => hasAllPermissions(admin, permissions),
    
    // Post-paid specific permissions
    canAccessPostPaidModule: () => canAccessPostPaidModule(admin),
    canCreatePostPaidRequest: () => canCreatePostPaidRequest(admin),
    canEditPostPaidRequest: () => canEditPostPaidRequest(admin),
    canApproveAsHOD: () => canApproveAsHOD(admin),
    canApproveAsFinance: () => canApproveAsFinance(admin),
    canApproveRequest: (request) => canApproveRequest(admin, request),
    
    // Get all post-paid permissions as object
    postPaidPermissions: getPostPaidPermissions(admin),
    
    // Permission constants
    POST_PAID_PERMISSIONS,
  };
};

export default usePermissions;

